import {createSelector} from 'reselect';
export const admins = state => state.admins;
export const adminsSelector = createSelector(admins, data => data);
